import http from '@utils/http';
/**
 * 点餐人列表
 */
export function mealOrderList() {
  return http.get('/api/meal/meal/order/list');
}

/**
 * 加班餐列表
 */
export function mealList() {
  return http.get('/api/meal/meal/order/meal/list');
}

/**
 * 取消点餐
 * @param { Object } params 参数
 */
export function mealCancelOrder(params) {
  return http.get('/api/meal/meal/order/cancel', {
    params,
  });
}

/**
 * 点餐
 * @param { Object } params 参数
 */
export function mealOrder(params) {
  return http.post('/api/meal/meal/order/meal', params);
}

/**
 * 评价
 * @param { Object } params 参数
 */
export function mealAddReview(params) {
  return http.post('/api/meal/meal/reviews/add', params);
}

/**
 * 取餐
 * @param { Object } params 参数
 */
export function mealTake(params) {
  return http.post('/api/meal/meal/take/takeMeal', params);
}

/**
 * 取餐信息
 * @param { Object } params 参数
 */
export function mealTakeInfo() {
  return http.get('/api/meal/meal/take/mealInfo');
}

/**
 * 委托
 * @param { Object } params 参数
 */
export function mealBailee(params) {
  return http.post('/api/meal/meal/take/setBailee', params);
}

/**
 * 取消委托
 * @param { Object } params 参数
 */
export function mealCancelBailee(params) {
  return http.post('/api/meal/meal/take/cancelBailee', params);
}

/**
 * 取餐结果
 * @param { Object } params 参数
 */
export function mealTakeResult(params) {
  return http.post('/api/meal/meal/take/mealTakeResult', params);
}

/**
 * 搜索员工
 * @param { Object } params 参数
 */
export function searchPerson(params, config) {
  return http.post('/api/meal/meal/take/searchPerson', params, config);
}

